import { useCallback, useEffect, useRef } from "react";
import debounce from "utils/debounce";

/**
 * Debounce useEffect
 */
const useLazyEffect = (effect, deps = [], wait = 300) => {
    const cleanUp = useRef();
    const effectRef = useRef();
    const updatedEffect = useCallback(
      effect, 
      [...deps, effect]
    );

    effectRef.current = updatedEffect;

    const lazyEffect = useCallback(
      debounce(() => {
        cleanUp.current = effectRef.current?.();
      }, wait),
      [], 
    );
    
    useEffect(lazyEffect, [...deps, lazyEffect]);

    useEffect(() => {
      return () => {
        if (cleanUp.current instanceof Function) {
          cleanUp.current();
        }
      };
    }, []);
}

export default useLazyEffect;